// extracted by mini-css-extract-plugin
var _1 = "CollaboratorStyles-module__collaborator___cpgCV";
var _2 = "CollaboratorStyles-module__collaborator_data____36TD";
var _3 = "CollaboratorStyles-module__collaborator_data_btnholder___fvN4I";
var _4 = "CollaboratorStyles-module__collaborator_data_nameholder___pkA7Y";
var _5 = "CollaboratorStyles-module__collaborator_img___Hf9jP";
var _6 = "CollaboratorStyles-module__collaborator_info___RxreW";
var _7 = "CollaboratorStyles-module__collaborator_name___Ph9Pl";
var _8 = "CollaboratorStyles-module__collaborator_data____36TD";
var _9 = "CollaboratorStyles-module__collaborator_data_btnholder___fvN4I";
var _a = "CollaboratorStyles-module__collaborator_data_nameholder___pkA7Y";
var _b = "CollaboratorStyles-module__collaborator_img___Hf9jP";
var _c = "CollaboratorStyles-module__collaborator_info___RxreW";
var _d = "CollaboratorStyles-module__collaborator_name___Ph9Pl";
export { _1 as "collaborator", _2 as "collaboratorData", _3 as "collaboratorDataBtnholder", _4 as "collaboratorDataNameholder", _5 as "collaboratorImg", _6 as "collaboratorInfo", _7 as "collaboratorName", _8 as "collaborator_data", _9 as "collaborator_data_btnholder", _a as "collaborator_data_nameholder", _b as "collaborator_img", _c as "collaborator_info", _d as "collaborator_name" }
